import { Layout } from "../components/Layout";
import { Panel } from "../components/Panel";
import { getLegalPage, type LegalPageKind } from "../lib/legalContent";
import { useWorkspaceLanguage, withLanguagePrefix } from "../lib/i18n";

interface LegalPageProps {
  kind: LegalPageKind;
}

export function LegalPage({ kind }: LegalPageProps) {
  const language = useWorkspaceLanguage();
  const page = getLegalPage(language, kind);
  const switchTarget = kind === "terms"
    ? language === "en" ? "/agb" : "/terms"
    : language === "en" ? "/datenschutz" : "/privacy";

  return (
    <Layout title={page.title} description={page.description}>
      <Panel variant="accent">
        <p className="form-note">{page.updated}</p>
        <div className="hero-actions">
          <a className="button button-secondary" href={withLanguagePrefix(switchTarget, language === "en" ? "de" : "en")}>
            {language === "en" ? "Deutsche Version" : "English version"}
          </a>
        </div>
      </Panel>
      <div className="legal-content">
        {page.sections.map((section) => (
          <Panel key={section.heading} title={section.heading}>
            {section.body.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </Panel>
        ))}
      </div>
    </Layout>
  );
}
